
import { TimelineEntry as TimelineEntryType } from "@/types";
import TimelineEntriesContainer from "./TimelineEntriesContainer";
import { sortEntriesAscending } from "@/utils/dateHelpers";

interface TimelineExpandedViewProps {
  entries: TimelineEntryType[];
  isEven: boolean;
  timelineOwnerId?: string;
}

const TimelineExpandedView = ({ 
  entries, 
  isEven,
  timelineOwnerId
}: TimelineExpandedViewProps) => {
  // Filter entries into specific (with year) and not-sure (without year) groups
  const specificEntries = entries.filter(entry => entry.year != null);
  const notSureEntries = entries.filter(entry => entry.year == null);

  // Sort specific entries in ascending order (oldest first)
  const sortedSpecificEntries = sortEntriesAscending(specificEntries);

  return (
    <>
      {/* Specific entries container */}
      {sortedSpecificEntries.length > 0 && (
        <TimelineEntriesContainer 
          entries={sortedSpecificEntries} 
          isEven={isEven} 
          type="specific"
          timelineOwnerId={timelineOwnerId}
        />
      )}
      
      {/* Not-sure entries container - only show if there are entries of this type */}
      {notSureEntries.length > 0 && (
        <TimelineEntriesContainer 
          entries={notSureEntries} 
          isEven={isEven} 
          type="not-sure"
          timelineOwnerId={timelineOwnerId}
        />
      )}
    </>
  );
};

export default TimelineExpandedView;
